const cop = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

export const formatCop = (n: number | string): string => cop.format(typeof n === 'string' ? Number(n) : n);

export const formatNumber = (n: number | string, digits = 2): string =>
  Number(n).toLocaleString('es-CO', { maximumFractionDigits: digits });

export function imageUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  return `/uploads/${path}`;
}
